export default __webpack_public_path__ + "static/media/vitol.c7d09493.svg";